import styled from "styled-components";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Furigana from "../../components/furigana";

const StyledMainPaper = styled(Paper)`
  scroll-margin: 70px;
  padding: 10px;
  margin-bottom: 10px;

  @media (min-width: 641px) {
    padding: 20px;
  }
`;

const StyledPaper = styled(Paper)`
  padding: 10px;

  @media (min-width: 641px) {
    padding: 20px;
    width: fit-content;
  }
`;

const Temporality = () => {
  const createData = (fr, jp) => {
    return { fr, jp };
  };

  const rowsYears = [
    createData("1 an", <Furigana center text="[一年=いちねん]" />),
    createData("2 ans", <Furigana center text="[二年=にねん]" />),
    createData("3 ans", <Furigana center text="[三年=さんねん]" />),
    createData("4 ans", <Furigana center text="[四年=よねん]" />),
    createData("5 ans", <Furigana center text="[五年=ごねん]" />),
    createData("6 ans", <Furigana center text="[六年=ろくねん]" />),
    createData("7 ans", <Furigana center text="[七年=ななねん、しちねん]" />),
    createData("8 ans", <Furigana center text="[八年=はちねん]" />),
    createData("9 ans", <Furigana center text="[九年=きゅうねん]" />),
    createData("10 ans", <Furigana center text="[十年=じゅうねん]" />),
    createData("Combien d’années ?", <Furigana center text="何年=なんねん]" />),
  ];

  const rowsMonths = [
    createData("1 mois", <Furigana center text="[一か月=いっかげつ]" />),
    createData("2 mois", <Furigana center text="[二か月=にかげつ]" />),
    createData("3 mois", <Furigana center text="[三か月=さんかげつ]" />),
    createData("4 mois", <Furigana center text="[四か月=よんかげつ]" />),
    createData("5 mois", <Furigana center text="[五か月=ごかげつ]" />),
    createData("6 mois", <Furigana center text="[六か月=ろっかげつ]" />),
    createData("7 mois", <Furigana center text="[七か月=ななかげつ]" />),
    createData("8 mois", <Furigana center text="[八か月=はちかげつ]" />),
    createData("9 mois", <Furigana center text="[九か月=きゅうかげつ]" />),
    createData("10 mois", <Furigana center text="[十か月=じゅっかげつ]" />),
    createData("11 mois", <Furigana center text="[十一か月=じゅういっかげつ]" />),
    createData("12 mois", <Furigana center text="[十二か月=じゅうにかげつ]" />),
    createData("Combien de mois ?", <Furigana center text="[何か月=なんかげつ]" />),
    createData("Tous les 6 mois", <Furigana center text="[六か月=ろっかげつ]に[1回=いっかい]&nbsp;&nbsp;/&nbsp;&nbsp;[半年=はんとし]に[1回=いっかい]" />),
  ];

  const rowsWeeks = [
    createData("1 semaine", <Furigana center text="[一週間=いっしゅうかん]" />),
    createData("2 semaines", <Furigana center text="[二週間=にしゅうかん]" />),
    createData("3 semaines", <Furigana center text="[三週間=さんしゅうかん]" />),
    createData("4 semaines", <Furigana center text="[四週間=よんしゅうかん]" />),
    createData("5 semaines", <Furigana center text="[五週間=ごしゅうかん]" />),
    createData("6 semaines", <Furigana center text="[六週間=ろくしゅうかん]" />),
    createData("7 semaines", <Furigana center text="[七週間=ななしゅうかん]" />),
    createData("8 semaines", <Furigana center text="[八週間=はっしゅうかん]" />),
    createData("9 semaines", <Furigana center text="[九週間=きゅうしゅうかん]" />),
    createData("10 semaines", <Furigana center text="[十週間=じゅっしゅうかん / じっしゅうかん]" />),
    createData("Combien de semaines ?", <Furigana center text="何週間=なんしゅうかん]" />),
  ];

  const rowsDays = [
    createData("Le 1er / 1 jour", <Furigana center text="[一日=ついたち / いちにち]" />),
    createData("Le 2 / 2 jours", <Furigana center text="[二日=ふつか]" />),
    createData("Le 3 / 3 jours", <Furigana center text="[三日=みっか]" />),
    createData("Le 4 / 4 jours", <Furigana center text="[四日=よっか]" />),
    createData("Le 5 / 5 jours", <Furigana center text="[五日=いつか]" />),
    createData("Le 6 / 6 jours", <Furigana center text="[六日=むいか]" />),
    createData("Le 7 / 7 jours", <Furigana center text="[七日=なのか]" />),
    createData("Le 8 / 8 jours", <Furigana center text="[八日=ようか]" />),
    createData("Le 9 / 9 jours", <Furigana center text="[九日=ここのか]" />),
    createData("Le 10 / 10 jours", <Furigana center text="[十日=とおか]" />),
    createData("Le 11 / 11 jours", <Furigana center text="[十一日=じゅういちにち]" />),
    createData("Le 14 / 14 jours", <Furigana center text="[十四日=じゅうよっか]" />),
    createData("Le 20 / 20 jours", <Furigana center text="[二十日=はつか]" />),
    createData("Le 24 / 24 jours", <Furigana center text="[二十四日=にじゅうよっか]" />),
    createData("Combien  de jours ?", <Furigana center text="[何日=なんにち]" />),
    createData("Il y a 3 jours", <Furigana center text="[三日=みっか][前=まえ]" />),
    createData("Pendant 3 jours", <Furigana center text="[三日間=みっかかん]" />),
    createData("Tous les 2 jours", <Furigana center text="[二日=ふつか][毎=ごと]に" />),
  ];

  const rowsHours = [
    createData("1 heure", <Furigana center text="[一時=いちじ]" />),
    createData("2 heures", <Furigana center text="[二時=にじ]" />),
    createData("3 heures", <Furigana center text="[三時=さんじ]" />),
    createData("4 heures", <Furigana center text="[四時=よじ]" />),
    createData("5 heures", <Furigana center text="[五時=ごじ]" />),
    createData("6 heures", <Furigana center text="[六時=ろくじ]" />),
    createData("7 heures", <Furigana center text="[七時=しちじ]" />),
    createData("8 heures", <Furigana center text="[八時=はちじ]" />),
    createData("9 heures", <Furigana center text="[九時=くじ]" />),
    createData("10 heures", <Furigana center text="[十時=じゅうじ]" />),
    createData("Combien d’heures ?", <Furigana center text="[何時=なんじ]" />),
  ];

  const rowsMinutes = [
    createData("1 minute", <Furigana center text="[一分=いっぷん]" />),
    createData("2 minutes", <Furigana center text="[二分=にふん]" />),
    createData("3 minutes", <Furigana center text="[三分=さんぷん]" />),
    createData("4 minutes", <Furigana center text="[四分=よんぷん]" />),
    createData("5 minutes", <Furigana center text="[五分=ごふん]" />),
    createData("6 minutes", <Furigana center text="[六分=ろっぷん]" />),
    createData("7 minutes", <Furigana center text="[七分=ななふん / しちふん]" />),
    createData("8 minutes", <Furigana center text="[八分=はっぷん / はちふん]" />),
    createData("9 minutes", <Furigana center text="[九分=きゅうふん]" />),
    createData("10 minutes", <Furigana center text="[十分=じゅっぷん / じっぷん]" />),
    createData("Combien de minutes ?", <Furigana center text="[何分=なんぷん]" />),
  ];

  const rowsSeconds = [
    createData("1 seconde", <Furigana center text="[一秒=いちびょう]" />),
    createData("2 secondes", <Furigana center text="[二秒=にびょう]" />),
    createData("3 secondes", <Furigana center text="[三秒=さんびょう]" />),
    createData("4 secondes", <Furigana center text="[四秒=よんびょう]" />),
    createData("5 secondes", <Furigana center text="[五秒=ごびょう]" />),
    createData("6 secondes", <Furigana center text="[六秒=ろくびょう]" />),
    createData("7 secondes", <Furigana center text="[七秒=ななびょう / しちびょう]" />),
    createData("8 secondes", <Furigana center text="[八秒=はちびょう]" />),
    createData("9 secondes", <Furigana center text="[九秒=きゅうびょう]" />),
    createData("10 secondes", <Furigana center text="[十秒=じゅうびょう]" />),
    createData("Combien de secondes ?", <Furigana center text="[何秒=なんびょう]" />),
  ];

  const rowsWeekdays = [
    createData("Lundi", <Furigana center text="[月曜日=げつようび]" />),
    createData("Mardi", <Furigana center text="[火曜日=かようび]" />),
    createData("Mercredi", <Furigana center text="[水曜日=すいようび]" />),
    createData("Jeudi", <Furigana center text="[木曜日=もくようび]" />),
    createData("Vendredi", <Furigana center text="[金曜日=きんようび]" />),
    createData("Samedi", <Furigana center text="[土曜日=どようび]" />),
    createData("Dimanche", <Furigana center text="[日曜日=にちようび]" />),
  ];

  const createDating = (date, day, week, month, year) => {
    return { date, day, week, month, year };
  };

  const rowsDating = [
    createDating(
      <span>- 2</span>,
      <span>
        <Furigana center text="[一昨日=おととい]" />
        Avant-hier
      </span>,
      <span>
        <Furigana center text="[先々週=せんせんしゅう]&nbsp;&nbsp;ou&nbsp;&nbsp;[二週間前=にしゅうかんまえ]" />
        Il y a 2 semaines
      </span>,
      <span>
        <Furigana center text="[先々月=せんせんげつ]&nbsp;&nbsp;ou&nbsp;&nbsp;[二か月前=にかげつまえ]" />
        Il y a 2 mois
      </span>,
      <span>
        <Furigana center text="[一昨年=おととし]" />
        Il y a 2 ans
      </span>,
    ),
    createDating(
      <span>- 1</span>,
      <span>
        <Furigana center text="[昨日=きのう]" />
        Hier
      </span>,
      <span>
        <Furigana center text="[先週=せんしゅう]" />
        La semaine dernière
      </span>,
      <span>
        <Furigana center text="[先月=せんげつ]" />
        Le mois dernier
      </span>,
      <span>
        <Furigana center text="[去年=きょねん]" />
        L’année dernière
      </span>,
    ),
    createDating(
      <span>0</span>,
      <span>
        <Furigana center text="[今日=きょう]" />
        Aujourd'hui
      </span>,
      <span>
        <Furigana center text="[今週=こんしゅう]" />
        Cette semaine
      </span>,
      <span>
        <Furigana center text="[今月=こんげつ]" />
        Ce mois-ci
      </span>,
      <span>
        <Furigana center text="[今年=ことし]" />
        Cette année
      </span>,
    ),
    createDating(
      <span>+ 1</span>,
      <span>
        <Furigana center text="[明日=あした]" />
        Demain
      </span>,
      <span>
        <Furigana center text="[来週=らいしゅう]" />
        La semaine prochaine
      </span>,
      <span>
        <Furigana center text="[来月=らいげつ]" />
        Le mois prochain
      </span>,
      <span>
        <Furigana center text="[来年=らいねん]" />
        L’année prochaine
      </span>,
    ),
    createDating(
      <span>+ 2</span>,
      <span>
        <Furigana center text="[明後日=あさって]" />
        Après-demain
      </span>,
      <span>
        <Furigana center text="[再来週=さらいしゅう]" />
        Dans 2 semaines
      </span>,
      <span>
        <Furigana center text="[再来月=さらいげつ]" />
        Dans 2 mois
      </span>,
      <span>
        <Furigana center text="[再来年=さらいねん]" />
        Dans 2 ans
      </span>,
    ),
    createDating(
      <span>x - 1</span>,
      <span>
        <Furigana center text="[前日=ぜんじつ]" />
        La veille
      </span>,
      <span>
        <Furigana center text="その[一週間前=いっしゅうかんまえ]" />
        La semaine suivante
      </span>,
      <span>
        <Furigana center text="その[一か月前=いっかげつまえ]" />
        Le mois suivant
      </span>,
      <span>
        <Furigana center text="[その前の年=そのまえのとし]" />
        L’année précédente
      </span>,
    ),
    createDating(
      <span>x + 1</span>,
      <span>
        <Furigana center text="[翌日=よくじつ]" />
        Le lendemain
      </span>,
      <span>
        <Furigana center text="[翌週=よくしゅう]" />
        La semaine suivante
      </span>,
      <span>
        <Furigana center text="[翌月=よくげつ]" />
        Le mois suivant
      </span>,
      <span>
        <Furigana center text="[翌年=よくとし]" />
        L’année suivante
      </span>,
    ),
    createDating(
      <span>. . .</span>,
      <span>
        <Furigana center text="[毎日=まいにち]" />
        Chaque jour
      </span>,
      <span>
        <Furigana center text="[毎週=まいしゅう]" />
        Chaque semaine
      </span>,
      <span>
        <Furigana center text="[毎月=まいつき]" />
        Chaque mois
      </span>,
      <span>
        <Furigana center text="[毎年=まいとし / まいねん]" />
        Chaque année
      </span>,
    ),
    createDating(
      <span>. . .</span>,
      <span>
        <Furigana center text="[先日=せんじつ]&nbsp;&nbsp;ou&nbsp;&nbsp;[この間=このあいだ]" />
        L’autre jour
      </span>,
    ),
  ];

  const rowsDuration = [
    createData("Pendant 8 heures", <Furigana center text="[八時間=はちじかん]" />),
    createData("Pendant 8 heures et demi", <Furigana center text="[八時間半=はちじかんはん]" />),
    createData("Pendant 3 jours", <Furigana center text="[三日間=みっかかん]" />),
    createData("Pendant 1 semaine", <Furigana center text="[一週間=いっしゅうかん]" />),
    createData("Pendant 2 mois", <Furigana center text="[二ヶ月間=にかげつかん]" />),
    createData("Pendant 4 ans", <Furigana center text="[四年間=よねんかん]" />),
    createData("Pendant les vacances", <Furigana center text="[休暇中=きゅうかちゅう]&nbsp;&nbsp;ou&nbsp;&nbsp;[休み=やすみ]の[間=あいだ]" />),
  ];

  const createDaytime = (day, morning, afternoon, night) => {
    return { day, morning, afternoon, night };
  };

  const rowsDay = [
    createDaytime(
      <span>
        <Furigana center text="[一昨日=おととい]" />
        Avant-hier
      </span>,
      <span>
        <Furigana center text="[一昨日=おととい]の[朝=あさ]" />
        Avant-hier matin
      </span>,
      <span>
        <Furigana center text="[一昨日=おととい]の[午後=ごご]" />
        Avant-hier après-midi
      </span>,
      <span>
        <Furigana center text="[一昨日=おととい]の[夜=よる]" />
        Avant-hier soir
      </span>,
    ),
    createDaytime(
      <span>
        <Furigana center text="[昨日=きのう]" />
        Hier
      </span>,
      <span>
        <Furigana center text="[昨日=きのう]の[朝=あさ]" />
        Hier matin
      </span>,
      <span>
        <Furigana center text="[昨日=きのう]の[午後=ごご]" />
        Hier après-midi
      </span>,
      <span>
        <Furigana center text="[昨日=きのう]の[夜=よる]" />
        Hier soir
      </span>,
    ),
    createDaytime(
      <span>
        <Furigana center text="[今日=きょう]" />
        Aujourd'hui
      </span>,
      <span>
        <Furigana center text="[今朝=けさ]" />
        Ce matin
      </span>,
      <span>
        <Furigana center text="[今日=きょう]の[午後=ごご]" />
        Cette après-midi
      </span>,
      <span>
        <Furigana center text="[今晩=こんばん]" />
        Ce soir
      </span>,
    ),
    createDaytime(
      <span>
        <Furigana center text="[明日=あした]" />
        Demain
      </span>,
      <span>
        <Furigana center text="[明日=あした]の[朝=あさ]" />
        Demain matin
      </span>,
      <span>
        <Furigana center text="[明日=あした]の[午後=ごご]" />
        Demain après-midi
      </span>,
      <span>
        <Furigana center text="[明日=あした]の[夜=よる]" />
        Demain soir
      </span>,
    ),
    createDaytime(
      <span>
        <Furigana center text="[明後日=あさって]" />
        Après-demain
      </span>,
      <span>
        <Furigana center text="[明後日=あさって]の[朝=あさ]" />
        Après-demain matin
      </span>,
      <span>
        <Furigana center text="[明後日=あさって]の[午後=ごご]" />
        Après-demain après-midi
      </span>,
      <span>
        <Furigana center text="[明後日=あさって]の[夜=よる]" />
        Après-demain soir
      </span>,
    ),
    createDaytime(
      <span>
        <Furigana center text="[毎日=まいにち]" />
        Chaque jour
      </span>,
      <span>
        <Furigana center text="[毎=まい][朝=あさ]" />
        Chaque matin
      </span>,
      <span>
        <Furigana center text="[毎日=まいにち]、[午後=ごご]に..." />
        Chaque après-midi
      </span>,
      <span>
        <Furigana center text="[毎=まい][晩=ばん]" />
        Chaque soir
      </span>,
    ),
    createDaytime(
      <span>
        <Furigana center text="[四時=よじ]" />4 heure
      </span>,
      <span>
        <Furigana center text="[午前五時=ごぜんごじ]" />5 heure du matin
      </span>,
      <span>
        <Furigana center text="[午後六時=ごごろくじ]" />6 heure de l'après-midi
      </span>,
      <span>
        <Furigana center text="[午後七時=ごごしちじ]" />7 heure du soir
      </span>,
    ),
  ];

  const rowsDaytime = [
    createData("Midi", <Furigana center text="[正午=しょうご]" />),
    createData("Minuit", <Furigana center text="[真ん中=まんなか]&nbsp;&nbsp;ou&nbsp;&nbsp;[零時=れいじ]" />),
    createData("Dans la nuit", <Furigana center text="[夜中=よなか]の" />),
    createData("Journée", <Furigana center text="[昼間=ひるま]" />),
    createData("Le matin et le soir", <Furigana center text="[朝晩=あさばん]" />),
  ];

  return (
    <StyledMainPaper elevation={3} id="temporality">
      <Typography variant="h4" gutterBottom>
        La Temporalité
      </Typography>

      <StyledMainPaper>
        <Typography variant="h5" gutterBottom sx={{ display: "flex", alignItems: "flex-end", lineHeight: 1.5 }}>
          Les siècles: <Furigana text="nombre+[世紀=せいき]" />
        </Typography>

        <StyledPaper variant="outlined">
          <Typography variant="body1">
            <Furigana text="[十八世紀=じゅうはっせいき] " />
          </Typography>
          <Typography variant="subtitle2">18ème siècle</Typography>
        </StyledPaper>
      </StyledMainPaper>

      <StyledMainPaper>
        <Typography variant="h5" gutterBottom sx={{ display: "flex", alignItems: "flex-end", lineHeight: 1.5 }}>
          Les années: <Furigana text="[年=ねん]" />
        </Typography>
        <Typography variant="body1" gutterBottom sx={{ display: "flex", alignItems: "flex-end" }}>
          Pour exprimer une durée, on ajoute <Furigana text="[間=かん]。" />
        </Typography>
        <StyledPaper variant="outlined">
          <Typography variant="body1">
            <Furigana text="[二=に][年=ねん][間=かん]" />
          </Typography>
          <Typography variant="subtitle2">Pendant 2 ans</Typography>
        </StyledPaper>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Français</TableCell>
                <TableCell align="center">Japonais</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsYears.map((row, index) => (
                <TableRow key={`row${index}`}>
                  <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                    {row.fr}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                    {row.jp}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </StyledMainPaper>

      <StyledMainPaper>
        <Typography variant="h5" gutterBottom>
          Les mois:
        </Typography>
        <StyledPaper variant="outlined">
          <Typography variant="body1">Début du mois</Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            <Furigana text="Mois + [上旬=じょうじゅん]" /> ou <Furigana text="Mois + の + はじめ" />
          </Typography>
        </StyledPaper>
        <StyledPaper variant="outlined">
          <Typography variant="body1">Milieu du mois</Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            <Furigana text="Mois + [中旬=ちゅうじゅん]" /> ou <Furigana text="Mois + の + [中頃=なかごろ]" />
          </Typography>
        </StyledPaper>
        <StyledPaper variant="outlined">
          <Typography variant="body1">Fin du mois</Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            <Furigana text="Mois + [下旬=げじゅん]" /> ou <Furigana text="Mois + の + おわり" />
          </Typography>
        </StyledPaper>
        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end" }}>
            Compter les mois : <Furigana text="か[月=げつ]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Pour exprimer une durée, on ajoute <Furigana text="[間=かん]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Pendant 2 mois : 2か
            <Furigana text="[月=げつ]" />
            <Furigana text="[間=かん]" />
          </Typography>
        </StyledPaper>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Français</TableCell>
                <TableCell align="center">Japonais</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsMonths.map((row, index) => (
                <TableRow key={`row${index}`}>
                  <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                    {row.fr}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                    {row.jp}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </StyledMainPaper>

      <StyledMainPaper>
        <Typography variant="h5" gutterBottom sx={{ display: "flex", alignItems: "flex-end", lineHeight: 1.5 }}>
          Les semaines: <Furigana text="[週間=しゅうかん]" />
        </Typography>
        <StyledPaper variant="outlined">
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Cette semaine ⇒ <Furigana text="[今週=こんしゅう]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            La semaine prochaine ⇒ <Furigana text="[来週=らいしゅう]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            La semaine derniere ⇒ <Furigana text="[先週=せんしゅう]" />
          </Typography>
        </StyledPaper>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Français</TableCell>
                <TableCell align="center">Japonais</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rowsWeeks.map((row, index) => (
                <TableRow key={`row${index}`}>
                  <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                    {row.fr}
                  </TableCell>
                  <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                    {row.jp}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </StyledMainPaper>

      <StyledMainPaper>
        <Typography variant="h5" gutterBottom sx={{ display: "flex", alignItems: "flex-end", lineHeight: 1.5 }}>
          Les jours : <Furigana text="[日=か、にち]" />
        </Typography>
        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            On indique le jour du mois à l’aide du numéro du jour suivi du compteur de jour <Furigana text="[日=にち]" />.
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Exemple : le 15 (ou 15 jours) ⇒ <Furigana text="[十五日=じゅうごにち]" />
          </Typography>
        </StyledPaper>
        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            C’est également ainsi que l’on compte les jours, à part pour 1 jour.
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Le 1er: <Furigana text="[一日=ついたち]" /> / 1 jour: <Furigana text="[一日=いちにち]" />
          </Typography>
        </StyledPaper>
        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Pour la durée, on ajoute <Furigana text="[間=かん]" />.
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Pendant 1 jour: <Furigana text="[一日間=いちにちかん]" />
          </Typography>
        </StyledPaper>
        <Paper variant="outlined" sx={{ p: 2, m: 2 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Français</TableCell>
                  <TableCell align="center">Japonais</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowsDays.map((row, index) => (
                  <TableRow key={`row${index}`}>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.fr}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.jp}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </StyledMainPaper>

      <StyledMainPaper>
        <Typography variant="h5" gutterBottom sx={{ display: "flex", alignItems: "flex-end", lineHeight: 1.5 }}>
          Les heures : <Furigana text="[時=じ]" />
        </Typography>
        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Pour exprimer une durée, on ajoute <Furigana text="[間=かん]" />.
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            A 1 heure ⇒ <Furigana text="[一=いち]" />
            <Furigana text="[時=じ]" />に
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Pendant une heure ⇒ <Furigana text="[一=いち]" />
            <Furigana text="[時=じ]" />
            <Furigana text="[間=かん]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Pendant une heure et demie ⇒ <Furigana text="[一=いち]" />
            <Furigana text="[時=じ]" />
            <Furigana text="[間=かん]" />
            <Furigana text="[半=はん]" />
          </Typography>
        </StyledPaper>
        <Paper variant="outlined" sx={{ p: 2, m: 2 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Français</TableCell>
                  <TableCell align="center">Japonais</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowsHours.map((row, index) => (
                  <TableRow key={`row${index}`}>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.fr}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.jp}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </StyledMainPaper>

      <StyledMainPaper>
        <Typography variant="h5" gutterBottom sx={{ display: "flex", alignItems: "flex-end", lineHeight: 1.5 }}>
          Les minutes : <Furigana text="[分=ふん]" />
        </Typography>
        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Pour exprimer une durée, on ajoute <Furigana text="[間=かん]" />.
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            A 5 minute ⇒ <Furigana text="[五=ご]" />
            <Furigana text="[分=ふん]" />に
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Pendant 5 minutes ⇒ <Furigana text="[五=ご]" />
            <Furigana text="[分=ふん]" />
            <Furigana text="[間=かん]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Pendant 5 minutes et demie ⇒ <Furigana text="[五=ご]" />
            <Furigana text="[分=ふん]" />
            <Furigana text="[半=はん]" />
          </Typography>
        </StyledPaper>
        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Exprimer l’heure :
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Et demie : 1 heure et demie ⇒ <Furigana text="[一時半=いちじはん]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Plus : 5 heure 25 ⇒ <Furigana text="[五時=ごじ]" />
            <Furigana text="[二十五分=にじゅうごふん]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Moins : 5 heure moins 15 ⇒ <Furigana text="[五時=ごじ]" />
            <Furigana text="[十五分=じゅうごふん]" />
            まえ
          </Typography>
        </StyledPaper>
        <Paper variant="outlined" sx={{ p: 2, m: 2 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Français</TableCell>
                  <TableCell align="center">Japonais</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowsMinutes.map((row, index) => (
                  <TableRow key={`row${index}`}>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.fr}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.jp}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </StyledMainPaper>

      <StyledMainPaper>
        <Typography variant="h5" gutterBottom sx={{ display: "flex", alignItems: "flex-end", lineHeight: 1.5 }}>
          Les secondes: <Furigana text="[秒=びょう]" />
        </Typography>
        <Paper variant="outlined" sx={{ p: 2, m: 2 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Français</TableCell>
                  <TableCell align="center">Japonais</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowsSeconds.map((row, index) => (
                  <TableRow key={`row${index}`}>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.fr}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.jp}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </StyledMainPaper>

      <StyledMainPaper>
        <Typography variant="h5" gutterBottom sx={{ display: "flex", alignItems: "flex-end", lineHeight: 1.5 }}>
          Les jours de la semaine :
        </Typography>
        <StyledPaper variant="outlined">
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Ce mardi ⇒ <Furigana text="[今週=こんしゅう]" />の
            <Furigana text="[火曜日=かようび]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Samedi prochain ⇒ <Furigana text="[来週=らいしゅう]" />の
            <Furigana text="[土曜日=どようび]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Samedi dernier ⇒ <Furigana text="[先週=せんしゅう]" />の
            <Furigana text="[土曜日=どようび]" />
          </Typography>
        </StyledPaper>
        <Paper variant="outlined" sx={{ p: 2, m: 2 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Français</TableCell>
                  <TableCell align="center">Japonais</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowsWeekdays.map((row, index) => (
                  <TableRow key={`row${index}`}>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.fr}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.jp}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </StyledMainPaper>

      <StyledMainPaper>
        <Typography variant="h5" gutterBottom sx={{ display: "flex", alignItems: "flex-end", lineHeight: 1.5 }}>
          Situer dans le temps :
        </Typography>

        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Avant + Nom ⇒ Nom + <Furigana text="の[前=まえ]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Avant le voyage: <Furigana text="[旅行=りょこう]の[前=まえ]" />
          </Typography>
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Avant + Verbe ⇒ V-neutre + <Furigana text="[前=まえ]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Avant de manger: <Furigana text="[食=た]べる[前=まえ]" />
          </Typography>
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Après + Nom ⇒ Nom + <Furigana text="の[後=あと]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Après le petit déjeuner: <Furigana text="[朝=あさ]ごはんの[後=あと]" />
          </Typography>
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Après + Verbe ⇒ V-て + <Furigana text="から" /> ou V-た + <Furigana text="[後=あと]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Après avoir écrit: <Furigana text="[書=か]いてから" /> ou <Furigana text="[書=か]いた[後=あと]" />
          </Typography>
        </StyledPaper>

        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Depuis ⇒ Durée + <Furigana text="[前=まえ]から" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            J’habite au Japon depuis 5 ans: <Furigana text="[五年=ごねん][前=まえ]から[日本=にほん]に[住=す]んでいます" />
          </Typography>
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Il y a ⇒ Durée + <Furigana text="[前=まえ]に" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Il y a 5 ans, je suis allé au Japon: <Furigana text="[五年=ごねん][前=まえ]に[日本=にほん]に[行=い]きました" />
          </Typography>
        </StyledPaper>

        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Dans ⇒ Durée + <Furigana text="[後=ご]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Dans 5 ans: <Furigana text="[五年=ごねん][後=ご]" />
          </Typography>
        </StyledPaper>

        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Quelques ⇒ <Furigana text="[数=すう]" /> + Période
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Dans quelques jours: <Furigana text="[数=すう]" />
            <Furigana text="[日=じつ]" />
            <Furigana text="[後=ご]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Quelques minutes avant: <Furigana text="[数=すう]" />
            <Furigana text="[分=ふん]" />
            <Furigana text="[前=まえ]" />
          </Typography>
        </StyledPaper>

        <Paper variant="outlined" sx={{ p: 2, m: 2 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center">Jour</TableCell>
                  <TableCell align="center">Semaine</TableCell>
                  <TableCell align="center">Mois</TableCell>
                  <TableCell align="center">Année</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowsDating.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "20%" }}>
                      {row.date}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "20%" }}>
                      {row.day}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "20%" }}>
                      {row.week}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "20%" }}>
                      {row.month}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "20%" }}>
                      {row.year}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </StyledMainPaper>

      <StyledMainPaper>
        <Typography variant="h5" gutterBottom sx={{ display: "flex", alignItems: "flex-end", lineHeight: 1.5 }}>
          La durée : <Furigana text="[間=かん]" />
        </Typography>

        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", flexWrap: "wrap", lineHeight: 2 }}>
            On utilise <Furigana text="[間=かん]" /> pour exprimer une durée, une période. <br />
            <Furigana text="[間=かん]" /> est toujours utilisé pour exprimer une durée en heures, en semaines ou en années. Dans les autres cas (minutes, secondes, jours, mois…){" "}
            <Furigana text="[間=かん]" /> n’est utilisé que si l’on veut mettre l’accent sur la période.
          </Typography>
        </StyledPaper>

        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Durée vague ⇒ <Furigana text="[久=ひさ]し" /> + <Furigana text="ぶりに" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Ca faisait longtemps qu’on ne s’était pas vus: <Furigana text="[久=ひさ]しぶりに[会=あ]った" />
          </Typography>
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Durée précise ⇒ Durée + <Furigana text="ぶりに" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Ca faisait 3 ans qu’on ne s’était pas vus: <Furigana text="[三年=さんねん]ぶりに[会=あ]った" />
          </Typography>
        </StyledPaper>

        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Différence entre Buri / Mae et Kan
          </Typography>
          <br />
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            <Furigana text="[二年=にねん]ぶりに[会=あ]いました" />。
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Ça faisait 2 ans que je ne l’avais pas vu. (⇒ maintenant je le/la vois)
          </Typography>
          <br />
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            <Furigana text="[二年=にねん]ぶりに[会=あ]います" />。
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Ça fait 2 ans que je ne l'ai pas vu. (⇒ je vais le/la voir maintenant)
          </Typography>
          <br />
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            <Furigana text="[二年=にねん][前=まえ]から[会=あ]っていません" />。
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Je ne l'ai pas vu depuis 2 ans. (⇒ je ne le/la vois toujours pas)
          </Typography>
          <br />
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            <Furigana text="[二年=にねん][間=かん][会=あ]っていません" />。
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Je ne l’ai pas vu pendant 2 ans. (⇒ <Furigana text="[間=かん]" small /> est ici pour insister sur la durée.)
          </Typography>
        </StyledPaper>

        <Paper variant="outlined" sx={{ p: 2, m: 2 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Français</TableCell>
                  <TableCell align="center">Japonais</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowsDuration.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.fr}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.jp}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </StyledMainPaper>

      <StyledMainPaper>
        <Typography variant="h5" gutterBottom sx={{ display: "flex", alignItems: "flex-end", lineHeight: 1.5 }}>
          La journée
        </Typography>

        <Paper variant="outlined" sx={{ p: 2, m: 2 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Français</TableCell>
                  <TableCell align="center">Japonais</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowsDaytime.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.fr}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "50%" }}>
                      {row.jp}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <Paper variant="outlined" sx={{ p: 2, m: 2 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Jour</TableCell>
                  <TableCell align="center">Matin</TableCell>
                  <TableCell align="center">Après-midi</TableCell>
                  <TableCell align="center">Soir</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowsDay.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "25%" }}>
                      {row.day}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "25%" }}>
                      {row.morning}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "25%" }}>
                      {row.afternoon}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" sx={{ width: "25%" }}>
                      {row.night}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </StyledMainPaper>

      <StyledMainPaper>
        <Typography variant="h5" gutterBottom sx={{ display: "flex", alignItems: "flex-end", lineHeight: 1.5 }}>
          Décennies, tranches d’ages <Furigana text="[代=だい]" />
        </Typography>

        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Décennies: Année + <Furigana text="[年=ねん]" /> + <Furigana text="[代=だい]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Les années 50: <Furigana text="[五十年代=ごじゅうねんだい]" />
          </Typography>
        </StyledPaper>

        <StyledPaper variant="outlined">
          <Typography variant="body1" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            Tranche d’age: Age + <Furigana text="[代=だい]" />
          </Typography>
          <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "flex-end", lineHeight: 2 }}>
            La cinquantaine: <Furigana text="[五十代=ごじゅうだい]" />
          </Typography>
        </StyledPaper>
      </StyledMainPaper>
    </StyledMainPaper>
  );
};

export default Temporality;
